import { TRUCK_TYPES_URL } from '@/constants';
import { ForbiddenError, NotFoundError, UnauthorizedError, UnexpectedError } from '@/services';
import { TruckTypeModel, TruckTypeServiceModel } from '@/types';
import { HttpStatusCode, fromBff, httpClient } from '@/utils';

export const loadTruckTypesService = async (): Promise<TruckTypeModel[]> => {
  const { body, status } = await httpClient.get<{ data: TruckTypeServiceModel[] }>(fromBff(TRUCK_TYPES_URL));

  const handleResult = (): TruckTypeModel[] => {
    if (!Boolean(body?.data?.length)) throw new NotFoundError();

    return body.data.map(({ amountComponents: compositions, truckSubtypes: subtypes, ...item }) => ({
      ...item,
      compositions,
      subtypes,
    }));
  };

  switch (status) {
    case HttpStatusCode.ok:
      return handleResult();

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    case HttpStatusCode.forbidden:
      throw new ForbiddenError();

    case HttpStatusCode.notFound:
      throw new NotFoundError();

    default:
      throw new UnexpectedError();
  }
};
